import { c as _c } from "react/compiler-runtime";
import PrimaryButton from "@/components/utils/button/PrimaryButton";
export default function GroupCardActionFooter(t0) {
  const $ = _c(9);
  const {
    loading,
    disabled,
    onSave,
    onCancel
  } = t0;
  let t1;
  if ($[0] !== onCancel) {
    t1 = <button type="button" onClick={onCancel} className="tw-inline-flex tw-items-center tw-border tw-border-solid tw-border-iron-700 tw-rounded-lg tw-bg-iron-800 tw-px-3.5 tw-py-2.5 tw-text-sm tw-font-semibold tw-text-iron-300 tw-shadow-sm hover:tw-bg-iron-700 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-iron-700 tw-transition tw-duration-300 tw-ease-out">Cancel</button>;
    $[0] = onCancel;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== disabled || $[3] !== loading || $[4] !== onSave) {
    t2 = <PrimaryButton loading={loading} disabled={disabled} onClicked={onSave}>Grant</PrimaryButton>;
    $[2] = disabled;
    $[3] = loading;
    $[4] = onSave;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <div className="tw-pt-3 tw-px-4 tw-mt-auto"><div className="tw-flex tw-items-center tw-gap-x-3 tw-justify-end">{t1}{t2}</div></div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}